import { ResponsiveGridLayout } from "react-grid-layout";
import type { Layout, ResponsiveLayouts } from "../../utils/dashboard.types";
import { WidgetGridItem } from "./WidgetGridItem";
import { RGL_BREAKPOINTS, RGL_COLS, getColsForWidth } from "../../utils/breakpoints";

const ROW_HEIGHT = 30;
const GRID_MARGIN = 10;

const CONTAINER_PADDING: [number, number] = [0, 0];

interface WidgetGridProps {
    activeWidgets: string[];
    layouts: ResponsiveLayouts;
    isCustomizing: boolean;
    width: number;
    onLayoutChange: (layout: Layout, allLayouts: Partial<Record<string, Layout>>) => void;
    onRemoveWidget: (widgetId: string) => void;
}

export function WidgetGrid({
    activeWidgets,
    layouts,
    isCustomizing,
    width,
    onLayoutChange,
    onRemoveWidget,
}: WidgetGridProps) {
    return (
        <div
            className={isCustomizing ? "min-h-[calc(100vh-200px)]" : ""}
            style={
                {
                    "--row-height": `${ROW_HEIGHT}px`,
                    "--grid-margin": `${GRID_MARGIN}px`,
                    "--grid-cols": getColsForWidth(width),
                } as React.CSSProperties
            }
        >
            <ResponsiveGridLayout
                className={isCustomizing ? "layout" : ""}
                layouts={layouts}
                breakpoints={RGL_BREAKPOINTS}
                cols={RGL_COLS}
                rowHeight={ROW_HEIGHT}
                width={width}
                margin={[GRID_MARGIN, GRID_MARGIN]}
                containerPadding={CONTAINER_PADDING}
                dragConfig={{ enabled: isCustomizing }}
                resizeConfig={{ enabled: isCustomizing }}
                onLayoutChange={onLayoutChange}
            >
                {activeWidgets.map((widgetId) => (
                    <div key={widgetId}>
                        <WidgetGridItem
                            widgetId={widgetId}
                            isCustomizing={isCustomizing}
                            onRemove={onRemoveWidget}
                        />
                    </div>
                ))}
            </ResponsiveGridLayout>
        </div>
    );
}
